import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import OrganizationAddButton from "@/modules/organization/organization-add-button";
import { OrganizationsListProvider } from "@/modules/organizations/organizations-list-provider";
import { OrganizationsListTable } from "@/modules/organizations/organizations-list-table";

const Organizations = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:organizations")} />
      <AppLayoutPage>
        <OrganizationsListProvider storageKey={STORAGE_KEYS.ORGANIZATIONS}>
          <OrganizationsListTable extraActions={<OrganizationAddButton />} />
        </OrganizationsListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Organizations;
